import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';

export const revisionHistoryDialogPromptStyle: React.CSSProperties = {
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  wordWrap: 'break-word'
};

export const revisionHistoryDialogGridContainerStyle: NestedCSSProperties = {
  position: 'relative',
};
